import React, { useEffect, useState } from "react";
import { Button, Dialog, EditIcon, PlusIcon, SearchInput, TrashIcon } from "evergreen-ui";
import { Card, Form, Input, message, Popconfirm, Select, Table } from "antd";
import FireFetch from "../../../Firebase/FireFetch";
import { TableExport } from "tableexport";
import { useListVals } from "../../../Firebase/databaseHooks";
import Firebase from "../../../Firebase/Firebase";
import { getDatabase, ref, update } from "firebase/database";
import TableActionMenu from "../../../Common/TableActionMenu";
import { filterSelectOption, sortSelectOptions } from "../../../utils/selectOptions.js";

var db = getDatabase(Firebase);
const DistrictsLayout = (props) => {
	const canCreate = props.canCreate !== false;
	const canUpdate = props.canUpdate !== false;
	const canDelete = props.canDelete !== false;
	const columns = [
		{
			title: 'District',
			dataIndex: 'district',
			key: 'district',
			sorter: (a, b) => a.district && a.district.localeCompare(b.district),

		},
		{
			title: 'Province',
			dataIndex: 'province',
			key: 'province',
			sorter: (a, b) => a.province && a.province.localeCompare(b.province),
		},
		{
			title: 'Country',
			dataIndex: 'country',
			key: 'country',
			sorter: (a, b) => a.province && a.province.localeCompare(b.province),
		},
		{
			title: 'Action',
			dataIndex: 'action',
			key: 'action',
		}
	]
	const [districtArray, setDistrictArray] = useState([]);
	const [districtsArray, loading] = useListVals(ref(db, "talmidsdb/district"));
	const [countries] = useListVals(ref(db, "talmidsdb/countries"));
	const [provinces] = useListVals(ref(db, "talmidsdb/province"));
	const [zones] = useListVals(ref(db, "talmidsdb/zones"));
	const [dataArray, setDataArray] = useState([]);
	const [editDistrict, setEditDistrict] = useState(null);
	const [showEditModal, setShowEditModal] = useState(false);

	useEffect(() => {
		if (districtsArray) {
			var tempArray = [];
			districtsArray?.map((item, index) => {
				tempArray.push({
					key: index,
					district: item.districtName,
					country: countries.find(x => (x.id === item.countryID))?.countryName,
					province: provinces.find(x => (x.id === item.provinceID))?.provinceName,
					action: (
						<TableActionMenu
							items={[
								canUpdate && {
									key: "edit",
									label: "Edit",
									onClick: () => {
										setEditDistrict(item);
										setShowEditModal(true);
									},
								},
								canDelete && {
									key: "delete",
									label: "Delete",
									danger: true,
									onClick: () => {
										if (confirm("Delete this district?")) {
											props.messageBack("district", "delete", item.id);
										}
									},
								},
							]}
						/>
					)

				})
			});

			setDataArray([...tempArray])
			setDistrictArray([...tempArray]);
		}

	}, [districtsArray, countries, props, canUpdate, canDelete]);

	const handleSearch = searchText => {
		const filteredEvents = dataArray.filter(({ district, province }) => {
			district = district.toLowerCase();
			province = province.toLowerCase();
			return province.includes(searchText) || district.includes(searchText);
		});

		setDistrictArray(filteredEvents);
	};

	const handleEdit = (values) => {
		if (!canUpdate) {
			message.error("You do not have permission to update districts.");
			return;
		}

		update(ref(db, "talmidsdb/district/" + editDistrict?.id), values).then(() => {
			message.success("District Updated");
			setShowEditModal(false);
		})
			.catch((error) => {
				message.error("Unable to update : " + error);
			})
	}

	return (
		<div className="font-Nunito">
			<Dialog title="Edit District"
				isShown={showEditModal}
				hasFooter={false}
				onCloseComplete={() => { setShowEditModal(false) }}>
				<Form
					layout="vertical"
					onFinish={handleEdit}
					initialValues={{
						districtName: editDistrict?.districtName,
						countryID: editDistrict?.countryID,
						provinceID: editDistrict?.provinceID,
						zoneID: editDistrict?.zoneID
					}}
				>
					<Form.Item label="Enter District name"
						name="districtName"
						rules={[{ required: true }]}
						className="d-flex flex-column my-2 mt-3">
						<Input
							className="w-100"
							name="text-input-name"
							placeholder="enter district name"
						/>
					</Form.Item>
					<Form.Item label="Enter Country name"
						name="countryID"
						className="d-flex flex-column my-2 mt-3">
						<Select placeholder="select Country"
							showSearch
							optionFilterProp="children"
							filterOption={filterSelectOption}
							filterSort={sortSelectOptions}>
							{countries.map((item, index) => (
								<Select.Option value={item.id} key={index}>{item.countryName}</Select.Option>
							))}
						</Select>
					</Form.Item>
					<Form.Item label="Enter District Province"
						name="provinceID"
						className="d-flex flex-column my-2">
						<Input
							className="w-100"
							name="text-input-name"
							placeholder="enter province"
						/>
					</Form.Item >
					<Form.Item
						label="Zone"
						name="zoneID">
						<Select placeholder="select Zone"
							showSearch
							optionFilterProp="children"
							filterOption={filterSelectOption}
							filterSort={sortSelectOptions}
						>
							{zones?.map((item, index) => (
								<Select.Option key={index} value={item.zoneID}>{item.zone}</Select.Option>
							))}
						</Select>
					</Form.Item>
					<Button appearance="primary" htmlType="submit" className="mt-2">Edit</Button>
				</Form>
			</Dialog>

			<div className="d-flex flex-row align-items-center">
				<SearchInput placeholder="Filter districts" onChange={e => handleSearch(e.target.value)} />
				{canCreate && (
					<Button appearance="primary" className="ml-3 my-2" onClick={() => {
						props.messageBack("district", "create");
					}}>
						New District <PlusIcon />
					</Button>
				)}
				<Button appearance="primary" className="mx-2" onClick={() => {
					FireFetch.exportXL(TableExport(document.getElementById("dataTable"), {
						filename: "Districts",
						exportButtons: false,
						sheetname: "Districts",
					}), districtArray);
				}}>
					Print
				</Button>
			</div>
			<Card className="d-flex flex-column">
				<div>
					<Table style={{ overflow: "auto" }} id={"dataTable"} dataSource={districtArray} loading={loading}
						pagination={{ defaultPageSize: 100, showSizeChanger: true, pageSizeOptions: ['100', '200', '300'] }}
						columns={columns} />
				</div>
			</Card>
		</div>

	);
}

export default DistrictsLayout;
